import { apiClient } from './client';

export async function getStripeStatus() {
  const { data } = await apiClient.get('/api/system/stripe/status');
  return data.data;
}

export async function getStripeWebhookEvents(params = {}) {
  const { data } = await apiClient.get('/api/system/stripe/webhook-events', { params });
  return data;
}

export async function getStripeWebhookEvent(id) {
  const { data } = await apiClient.get(`/api/system/stripe/webhook-events/${id}`, {
    params: { include_payload: true },
  });
  return data.data;
}

export async function retryStripeWebhookEvent(id) {
  const { data } = await apiClient.post(`/api/system/stripe/webhook-events/${id}/retry`);
  return data.data;
}

export async function getStripeSyncLogs(params = {}) {
  const { data } = await apiClient.get('/api/system/stripe/sync-logs', { params });
  return data;
}

export async function syncAllStripeModulePrices(payload = {}) {
  const { data } = await apiClient.post('/api/system/stripe/module-prices/sync-all', payload);
  return data;
}

export async function createStripeTestCheckoutInvoice(customerId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/stripe/customers/${customerId}/test-checkout-invoice`, payload);
  return data;
}

export async function syncStripeCustomer(customerId) {
  const { data } = await apiClient.post(`/api/system/stripe/customers/${customerId}/sync`);
  return data.data;
}

export async function syncStripePlan(planId) {
  const { data } = await apiClient.post(`/api/system/stripe/plans/${planId}/sync`);
  return data.data;
}

export async function syncStripeSubscription(subscriptionId) {
  const { data } = await apiClient.post(`/api/system/stripe/subscriptions/${subscriptionId}/sync`);
  return data.data;
}

export async function createSystemStripePortalSession(customerId) {
  const { data } = await apiClient.post(`/api/system/stripe/customers/${customerId}/portal-session`);
  return data.data;
}

export async function createCustomerPortalStripeSession(customerId) {
  const { data } = await apiClient.post(`/api/customer-portal/customers/${customerId}/billing/stripe-portal-session`);
  return data.data;
}
